"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultiValueContainer;
var _react = _interopRequireDefault(require("react"));
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _Chip = _interopRequireDefault(require("../../Chip"));
/* eslint react/prop-types: 0 */
var _ref2 = /*#__PURE__*/_react["default"].createElement(_Close["default"], null);
function MultiValueContainer(_ref) {
  var data = _ref.data,
    removeProps = _ref.removeProps,
    selectProps = _ref.selectProps;
  // Grab onClick and onTouchEnd (screen devices) to pass
  // on to the onDelete callback in the chip
  var onClick = removeProps.onClick,
    onTouchEnd = removeProps.onTouchEnd;
  var handleOnDelete = function handleOnDelete(event) {
    onClick(event);
    onTouchEnd(event);
  };
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
    className: selectProps.classes.chip,
    "data-metrics": selectProps.dataMetrics.multiValue,
    deleteIcon: _ref2,
    onDelete: function onDelete(event) {
      handleOnDelete(event);
    },
    label: data.label,
    size: "small"
  });
}